export const AI_SESSION_EXPIRED = "Your session has expired. Please log in again.";
export const AI_IMAGE_TOO_LARGE = "Please upload an image smaller than 5 MB.";
export const AI_UNAVAILABLE = "Service is temporarily unavailable. Please try again.";
export const AI_USAGE_LIMIT = "You have reached the usage limit. Please try again later.";

export function aiErrorMessage(status, { imageUpload } = {}) {
	if (status === 401) return AI_SESSION_EXPIRED;
	if (status === 413 && imageUpload) return AI_IMAGE_TOO_LARGE;
	if (status === 429 || status === 403) return AI_USAGE_LIMIT;
	if (status === 503) return AI_UNAVAILABLE;
	return null;
}
